import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 


const LabelList = lazy(() => import("../pages/label/LabelList"));
const LabelEdit = lazy(() => import("../pages/label/LabelEdit"));
const LabelAdd = lazy(() => import("../pages/label/LabelAdd"));



const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/label" />
    ),
  },
  {
    path: "/label",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <LabelList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/label/edit-label",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
           <LabelEdit /> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/label/add-label",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <LabelAdd/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };